/** Ryze AbilitySpec seed kit. */
export const RYZE_ABILITY_DEFS = [
  {
    id: 'ryze_q',
    champKey: 'ryze',
    slot: 'Q',
    name: 'Overload',
    targeting: 'skillshot_line',
    range: 1000,
    castTime: 0.25,
    travelSpeed: 1700,
    width: 110,
    radius: 55,
    cooldown: 5,
    manaCost: 40,
    vfxId: 'ryze_q',
    status: 'wired'
  },
  {
    id: 'ryze_w',
    champKey: 'ryze',
    slot: 'W',
    name: 'Rune Prison',
    targeting: 'targeted',
    range: 550,
    castTime: 0.25,
    travelSpeed: null,
    width: null,
    radius: null,
    cooldown: 11,
    manaCost: 50,
    vfxId: 'ryze_w',
    status: 'wired'
  },
  {
    id: 'ryze_e',
    champKey: 'ryze',
    slot: 'E',
    name: 'Spell Flux',
    targeting: 'targeted',
    range: 550,
    castTime: 0.25,
    travelSpeed: null,
    width: null,
    radius: 350,
    cooldown: 3.5,
    manaCost: 35,
    vfxId: 'ryze_e',
    maxBounces: 5,
    status: 'wired'
  },
  {
    id: 'ryze_r',
    champKey: 'ryze',
    slot: 'R',
    name: 'Realm Warp',
    targeting: 'ground_aoe',
    range: 3000,
    castTime: 0,
    channelTime: 2,
    travelSpeed: null,
    width: null,
    radius: 275,
    cooldown: 80,
    manaCost: 100,
    vfxId: 'ryze_r',
    duration: 0,
    status: 'wired'
  }
];
